import { useState } from "react";
// import { useSnackbar } from "react-simple-snackbar";
import useAuth from "./useAuth";
import { MonStockConfigType, StockItConfigType, WMSConfigType } from "$types";
import { WMSConfigServices } from "$services";

const useWMSConfigForm = (postSubmitAction?: any) => {
  const { token, user } = useAuth();

  const [submitting, setSubmitting] = useState(false);
  const [isOpened, setOpen] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  /*
  const snackbarOptions = {
    position: "bottom-center",
    style: {
      backgroundColor: "#82bea2",
      color: "#fff",
      fontFamily: "Work Sans, sans-serif",
      fontSize: "14px",
      textAlign: "center",
      zIndex: "9990 !important",
    },
  };
  const [openSnackbar] = useSnackbar(snackbarOptions as any);
   */

  const openPopin = () => {
    setOpen(true);
  };

  const togglePopin = (isOpen: boolean) => {
    if (!isOpen) {
      setError("");
    }
    setOpen(isOpen);
  };

  const handleSubmit = async (
    values: WMSConfigType<StockItConfigType | MonStockConfigType>
  ) => {
    try {
      const copy = { ...values, createdBy: user?.userInfo?.id };
      setSubmitting(true);
      const Service = copy._id
        ? WMSConfigServices.UpdateWMSConfig
        : WMSConfigServices.CreateWMSConfig;
      Service(token, copy, copy._id)
        .then((res) => {
          if (res?.error) {
            setError(res.error);
          } else {
            togglePopin(false);
            setError("");
            if (postSubmitAction) postSubmitAction(res);
          }
        })
        .catch((err) => {
          setError(err.error || err.message || "Erreur Serveur");
        })
        .finally(() => {
          setSubmitting(false);
        });
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.log("WMSConfig ERROR : ", err?.message || "Erreur Serveur");
    }
  };

  const handleDelete = (id: string) => {
    try {
      setSubmitting(true);
      WMSConfigServices.DeleteWMSConfig(token, id)
        .then((res) => {
          if (res?.error) {
            setError(res.error);
          } else {
            togglePopin(false);
            setError("");
            if (postSubmitAction) postSubmitAction(res);
          }
        })
        .catch((err) => {
          setError(err.error || err.message || "Erreur Serveur");
        })
        .finally(() => {
          setSubmitting(false);
        });
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.log("WMSConfig ERROR : ", err?.message || "Erreur Serveur");
    }
  };

  return {
    error,
    handleSubmit,
    handleDelete,
    isOpened,
    openPopin,
    submitting,
    togglePopin,
  };
};

export default useWMSConfigForm;
